import { configureStore } from "@reduxjs/toolkit";
import loadingReducer from "./loading/loading.slice";
import navbarReducer from "./navbar/navbar.slice";
import stepReducer from "./step-personal-management/step.slice";
import treeViewReducer from "./tree-view/tree-view.slice";
import profileReducer from "./profile/profile.slice";
import apiReducer from './api/apiSlice';
// const preloadedState = loadState();

const store = configureStore({
  reducer: {
    loading: loadingReducer,
    navbar: navbarReducer,
    step: stepReducer,
    treeViewData: treeViewReducer,
    profile: profileReducer,
    api: apiReducer
  },
  //   preloadedState: {
  //     fiscalYear: preloadedState || undefined,
  //   },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  // middleware: [
  //   ...getDefaultMiddleware({
  //     serializableCheck: false,
  //   }),
  // ],
});

// store.subscribe(() => {
//   saveState(store.getState().fiscalYear);
// });

export default store;

export type RootState = ReturnType<typeof store.getState>;

